import {OfferKmId, PropertyKmId} from "@/types/ids";

export function getLeadMutationKey(propertyId: PropertyKmId) {
    return `propertyLead_${propertyId}`;
}

/** Kept apart from the property key - an offer and a unit can share the same numeric id. */
export function getInvestmentLeadMutationKey(offerId: OfferKmId) {
    return `offerLead_${offerId}`;
}
import {OfferKmId, PropertyKmId} from "@/types/ids";

export function getLeadMutationKey(propertyId: PropertyKmId) {
    return `propertyLead_${propertyId}`;
}

/** Kept apart from the property key - an offer and a unit can share the same numeric id. */
export function getInvestmentLeadMutationKey(offerId: OfferKmId) {
    return `offerLead_${offerId}`;
}
